import { axiosWithAuth } from "../../helpers";

export const merchantsService = {
	getFilteredMerchants,
	getAgents,
	getManagersAgent,
	getAgentCompanies,
	getAgent,
	updateAgent,
	getWhoCantTheySee,
	getWhoCanSeeThem,
	getAgentSetupMerchantsList,
	updateMerchantUserLinks,
};

const API_URL = process.env.REACT_APP_API_URL;

const PAGE_SIZE = 50;

function getFilteredMerchants({ pattern, page }) {
	return axiosWithAuth({
		url: `${API_URL}/api/merchants/list`,
		method: "POST",
		data: {
			page,
			pageSize: 20,
			pattern,
		},
	});
}

function getAgents({ page, sort, filtersApplied }) {
	const businessUnit = filtersApplied?.businessUnit?.parent
		? filtersApplied?.businessUnit?.parent?.name
		: filtersApplied?.businessUnit?.name;

	const businessUnitHierarchy =
		filtersApplied?.businessUnit?.parent &&
		filtersApplied?.businessUnit?.name;

	const options = {
		method: "GET",
		params: {
			page_index: page,
			page_size: PAGE_SIZE,
			full_name: filtersApplied?.fullName,
			agent_office: filtersApplied?.agentOffice,
			is_active: filtersApplied?.isActive?.value,
			manager_id: filtersApplied?.managerId?.id,
			roles: filtersApplied?.role?.value,
			business_unit: businessUnit,
			business_unit_hierarchy: businessUnitHierarchy,
			sort_type: sort?.id || undefined,
			ascending: sort?.id ? sort?.desc : undefined,
		},
		url: `${API_URL}/api/agents`,
	};

	return axiosWithAuth(options);
}

function getManagersAgent({ page }) {
	const options = {
		method: "POST",
		data: {
			page,
			pageSize: PAGE_SIZE,
		},
		url: `${API_URL}/api/agents/managers`,
	};

	return axiosWithAuth(options);
}

function getAgentCompanies() {
	const options = {
		method: "GET",
		url: `${API_URL}/api/agents/companies`,
	};

	return axiosWithAuth(options);
}

function getAgent(userId) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/agents/${userId}`,
	};

	return axiosWithAuth(options);
}

function updateAgent(userId, model) {
	const options = {
		method: "PUT",
		data: model,
		url: `${API_URL}/api/agents/${userId}`,
	};

	return axiosWithAuth(options);
}

function getWhoCantTheySee(userId) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/agents/${userId}/children`,
	};

	return axiosWithAuth(options);
}

function getWhoCanSeeThem(userId) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/agents/${userId}/parents`,
	};

	return axiosWithAuth(options);
}

function getAgentSetupMerchantsList(userId) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/agents/${userId}/merchants`,
	};

	return axiosWithAuth(options);
}

function updateMerchantUserLinks({ agentId, links }) {
	return axiosWithAuth({
		method: "POST",
		data: links,
		url: `${API_URL}/api/agents/${agentId}/link-merchants`,
	});
}
